import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/auth-context';
import PrivateRoute from './auth/private-route';
import Navigation from './components/nav_bar';
import Dashboard from './components/Dashboard';
import SatoshiAccount from './components/SatoshiAccount';
import SatoshiProfile from './components/SatoshiProfile';
import ExchangeClientTrades from './components/ExchangeClientTrades';
import Trade from './components/Trade';
import Login from './components/login-register/login';
import Register from './components/login-register/register';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Navigation />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/satoshi-account/:tg_chat_id" element={<SatoshiAccount />} />
            <Route path="/satoshi-profile/:profileId" element={<SatoshiProfile />} />
            <Route
              path="/exchange-client-trades/:profileId/:exchangeClientId"
              element={<ExchangeClientTrades />}
            />
            <Route path="/trade/:tradeId" element={<Trade />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
